import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2UnavailableLabel = (props: Props) => {
  const { children, sizeMatch = DEFAULT_SIZE_MATCH } = props;

  return (
    <BodyText sizeMatch={sizeMatch} style={styles.text} maxFontSizeMultiplier={1.2}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.CAUTION,
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_SIZE_MATCH: SizeMatch = ['14'];

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  sizeMatch?: SizeMatch;
}>;

type SizeMatch = ComponentProps<typeof BodyText>['sizeMatch'];
